import { loginModuleQuery, useModule } from 'system/structure-modules';

export default function LoginCodeRedirectScreen() {
    const { CodeRedirectScreen } = useModule(loginModuleQuery);
    return <CodeRedirectScreen />;
}
